export const FETCH_INCIDENT_DATA = "FETCH_INCIDENT_DATA";
export const FETCHED_INCIDENT_DATA = "FETCHED_INCIDENT_DATA";